import React from 'react';
import DateField from './DateField';

// Renders inside a TrackerCard.  Props:
//   r        — the tracker record object
//   set      — patch function (merges partial update into r)
//   title    — card title string (default "Reinnoire")
//   TrackerCard — the local TrackerCard component from the host tracker
export default function ReinnoireCard({ r, set, TrackerCard }) {
  function handleDepusaChange(checked) {
    const patch = { reinnoire_depusa: checked };
    if (!checked) patch.reinnoire_ciclu_expirare = null;
    set(patch);
  }

  function handleNewDateChange(v) {
    const patch = { dataExpirare: v };
    // Keep ciclu in sync with dataExpirare while depusa is checked,
    // so cicluSatisfied = true once the new date is saved
    if (r.reinnoire_depusa) patch.reinnoire_ciclu_expirare = v || null;
    set(patch);
  }

  return (
    <TrackerCard title="Reinnoire">
      <label className="check-label">
        <input
          type="checkbox"
          checked={!!r.reinnoire_anuntat_client}
          onChange={e => set({ reinnoire_anuntat_client: e.target.checked })}
        />
        Anunțat clientul
      </label>
      <label className="check-label">
        <input
          type="checkbox"
          checked={!!r.reinnoire_depusa}
          onChange={e => handleDepusaChange(e.target.checked)}
        />
        Reinnoirea depusă
      </label>
      {r.reinnoire_depusa && (
        <div className="field" style={{ marginTop: 8 }}>
          <label>Data nouă de expirare</label>
          <DateField
            value={r.dataExpirare || ''}
            onChange={handleNewDateChange}
          />
        </div>
      )}
    </TrackerCard>
  );
}
